export default function ($scope, link) {
    $scope.link = link;
};
